import { VoltageSpeedChargingAssessment, VoltageSpeedDashboardSample, VoltageSpeedDashboardSummary } from '../../voltage-with-speed.models';
import { formatEngineOnDuration } from '../kpis/kpis.utils';
import { getSpeedVoltageCorrelation, getSpeedVoltagePoints } from '../speed-voltage-scatter/speed-voltage-scatter.utils';

export function buildDailyInsights(summary: VoltageSpeedDashboardSummary | null, samples: VoltageSpeedDashboardSample[], assessment: VoltageSpeedChargingAssessment | null) {
  const points = getSpeedVoltagePoints(samples);
  const average = points.length ? points.reduce((sum, point) => sum + point.voltage / points.length, 0) : null;
  return {
    movingAverage: average !== null && Number.isFinite(average) ? average : null,
    idleDuration: formatEngineOnDuration(summary?.IdleSeconds),
    correlation: getSpeedVoltageCorrelation(points),
    assessmentNote: typeof assessment?.AssessmentNote === 'string' ? assessment.AssessmentNote.trim() : ''
  };
}
